import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexColumn, FlexRowFlexStart } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const BacklinksOverviewSingleMetricWidgetContainer = styled(FlexColumn)`
    width: 100%;
    gap: 8px;
    padding: 18px 24px;
`;

export const TitleRow = styled(FlexRowFlexStart)`
    align-items: center;
    gap: 5px;
`;

export const Tooltip = styled.div`
    padding-bottom: 2px;
`;

export const Title = styled.div`
    ${setFontVariant("subTitle3Alt", colorsPalettes.carbon[500])};
`;

export const ValuesRow = styled(FlexRowFlexStart)`
    align-items: center;
    height: 24px;
    gap: 8px;
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
`;

export const ChangeValueWrapper = styled.div`
    ${setFontVariant("input2")};
`;
